<template>
  <div>
    <div class="page-header">
      <v-layout row align-center>
        <v-icon x-large>mdi-link</v-icon>
        <h1 class="page-title">{{ pageTitle }}</h1>
      </v-layout>
    </div>
    <v-form v-model="valid">
      <v-container>
        <v-row>
          <v-col cols="12" lg="3" md="3" sm="12"
            ><v-text-field
              v-model="link.title"
              label="Title"
              :rules="titleRules"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" lg="2" md="2" sm="6">
            <v-checkbox
              v-model="link.active"
              label="Active"
            ></v-checkbox>
          </v-col>
          <v-col cols="12" lg="2" md="2" sm="6">
            <v-text-field
              label="Priority"
              required
              type="number"
              v-model="link.priority"
              :rules="[v => !!v || 'Priority is required']"
            ></v-text-field>
          </v-col>
          <v-col  cols="12" lg="5" md="5" sm="12"
            ><v-text-field
              v-model="link.link"
              label="Url"
              :rules="urlRules"
              required
            ></v-text-field
          ></v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              auto-grow
              v-model="link.description"
              label="Description"
              :rules="descriptionRules"
              required
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-spacer></v-spacer>
          <v-btn outlined color="accent" class="mr-4" @click="onBack"
            >Back</v-btn
          >
          <v-btn
            outlined
            :disabled="!valid"
            class="mr-4"
            @click="onSubmit"
            >Submit</v-btn
          >
        </v-row>
      </v-container>
    </v-form>
    <div>
      <statusalert ref="alert" returnUrl="/faq"></statusalert>
    </div>
  </div>
</template>
<script>
import LinksService from '../../services/api/LinksService.js'
import store from '@/store/index.js'
import router from '@/router/index.js'
import statusalert from '../../components/StatusAlert'
import authorizedMixin from '../../mixins/authorizedMixin'
  
export default {
  name: 'link-edit',
  mixins: [authorizedMixin],
  components: {
    statusalert
  },

  store: store,

  data() {
    return {
      result: null,
      pageTitle: 'Add Link',
      link: {
        linkId: 0,
        active: true,
        link: '',
        title: '',
        description: '',
        priority: 3
      },
      titleRules: [v => !!v || 'Title is required'],
      linkRules: [v => !!v || 'Link is required'],
      urlRules: [v => !!v || 'Url is required'],
      descriptionRules: [v => !!v || 'Description is required'],
      valid: false
    }
  },

  created() {
    if (!this.priviledged) {
      router.push('/unauth/')
    }
    store.commit('loading')
    if (this.$route.params.linkId > 0) {
      this.pageTitle = 'Edit Link'
      LinksService.getLink(this.$route.params.linkId)
        .then(data => {
          this.link = data
        })
        .catch(error => console.log(error))
        .finally(() => {
          store.commit('notLoading')
        })
    }
  },
  computed: {
    priviledged() {
      return (
        this.$store.getters.getAdministrator || this.$store.getters.getProShop
      )
    }
  },

  methods: {
    onBack() {
      router.push('/links')
    },

    onSubmit() {
      store.commit('isLoading')
      const x = parseInt(this.link.priority)
      this.link.priority = x

      this.result = {}
      if (this.link.linkId === 0) {
        LinksService.create(this.link)
          .then(result => {
            this.result = {
              isValid: true,
              statusCode: result.status,
              errors: ['Link created']
            }
          })
          .catch(error => {
            console.log(error)
            this.result = {
              isValid: false,
              statusCode: 404,
              errors: ['Failed to create Link']
            }
          })
          .finally(() => {
            store.commit('notLoading')
            this.displayAlert()
          })
      } else {
        LinksService.update(this.link)
          .then(result => {
            this.result = {
              isValid: true,
              statusCode: result.status,
              errors: ['Link updated']
            }
          })
          .catch(error => {
            console.log(error)
            this.result = {
              isValid: false,
              statusCode: 404,
              errors: ['Failed to update Link']
            }
          })
          .finally(() => {
            store.commit('notLoading')
            this.displayAlert()
          })
      }
    },

    displayAlert() {
      this.$refs.alert.displayResult(this.result)
    }
  }
}
</script>
<style lang="scss" scoped>
.button {
  padding: 5px;
}
.v-picker__title {
  height: 88px;
}
</style>
